import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';
import { normalizeUtcDayRangeFilters } from '../../core/utils/utils';
import {
	ICompanyConsumptionsSnapshot,
	IDashboardFilters,
	IGraphProcessResponse,
	IRejectedByErrorCodePayload,
	IRejectedByErrorCodeResponse,
	ITopNationalityProcessesResponse,
	ITotalProcessDateResponse,
} from '../models/panel.models';

@Injectable({
	providedIn: 'root',
})
export class PanelService extends ApiService {
	public getGraphProcess(body: IDashboardFilters): Observable<IGraphProcessResponse> {
		body = this.removePeriodFilter(body);
		return this.http.post<IGraphProcessResponse>(environment.apiUrl + `/dashboard/graph-process`, body, {
			headers: this.getHeaders(),
		});
	}

	public getTopNationalityProcesses(body: IDashboardFilters): Observable<ITopNationalityProcessesResponse> {
		body = this.removePeriodFilter(body);
		return this.http.post<ITopNationalityProcessesResponse>(
			environment.apiUrl + `/dashboard/top-nationality-processes`,
			body,
			{ headers: this.getHeaders() },
		);
	}

	public getTotalProcessDate(body: IDashboardFilters): Observable<ITotalProcessDateResponse> {
		body = this.removePeriodFilter(body);
		return this.http.post<ITotalProcessDateResponse>(environment.apiUrl + `/dashboard/total-process-date`, body, {
			headers: this.getHeaders(),
		});
	}

	/** Agregado de rechazos por `details_code`. Solo superadmin en back (403) y front. */
	public getRejectedByErrorCode(body: IRejectedByErrorCodePayload): Observable<IRejectedByErrorCodeResponse> {
		body = this.removePeriodFilter(body) as IRejectedByErrorCodePayload;
		return this.http.post<IRejectedByErrorCodeResponse>(
			environment.apiUrl + `/dashboard/rejected-by-error-code`,
			body,
			{ headers: this.getHeaders() },
		);
	}

	// TODO: Confirmar endpoint y respuesta
	public contactExpert(body: any): Observable<any> {
		return this.http.post<any>(environment.apiUrl + `/dashboard/contact-expert`, body, {
			headers: this.getHeaders(),
		});
	}

	/**
	 * NIF-775: snapshot de consumptions / saldo (Sanctum).
	 * Proxy admin_back → PWCS con KEY_CRON server-side (`GetCompanyConsumptionsController`).
	 */
	public getCompanyConsumptions(companyId: number): Observable<ICompanyConsumptionsSnapshot> {
		return this.http.get<ICompanyConsumptionsSnapshot>(
			environment.apiUrl + `/company/${companyId}/consumptions`,
			{ headers: this.getHeaders() },
		);
	}

	/**
	 * Misma transformación que aplican los POST del dashboard antes de enviar el body (p. ej. para curl de depuración).
	 */
	public prepareDashboardPostBody(filters: IDashboardFilters): IDashboardFilters {
		const newFilters = { ...(filters as Record<string, unknown>) };
		if (newFilters['period']) delete newFilters['period'];
		normalizeUtcDayRangeFilters(newFilters);
		// NIF-982: TZ del navegador para que graph-process agrupe por día local (no UTC).
		newFilters['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
		return newFilters as IDashboardFilters;
	}

	private removePeriodFilter(filters: IDashboardFilters): IDashboardFilters {
		return this.prepareDashboardPostBody(filters);
	}
}
